import React from "react"

import Layout from '@components/Layout';
import SEO from '@components/SEO';
import RegisterForm from '@components/RegisterForm';

const Register = () => {
    return <Layout>
        <SEO title={'Sign Up'} />
        <RegisterForm />
    </Layout>
}

export default  Register